/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { TransportMiddlewareProps } from '../../../../core';

import type { TransportMiddlewareContext, TransportMiddlewareRequest, TransportMiddlewareResponse, NextFunction } from '../../../../core';

export const checkResponseDataForErrorMiddleware = <T, R, E>(
    next: NextFunction<TransportMiddlewareResponse<R, E> | Error>,
    ctx: TransportMiddlewareContext,
    req: TransportMiddlewareRequest<T>,
    res: TransportMiddlewareResponse<R, E>
) => {
    const { commands, isErrorResponseData } = ctx;
    const { url, options } = req;
    const { notShowDefaultError, backendErrorTitle, type } = options;
    const responseData = res[TransportMiddlewareProps.ResponseProp];
    const isErrorResponse = isErrorResponseData(responseData);

    if (isErrorResponse) {
        if (!notShowDefaultError) {
            commands.showBackendError(responseData as any as E, {
                url,
                title: backendErrorTitle ?? null,
                type,
            });
        }

        res[TransportMiddlewareProps.ErrorResponse] = responseData as any as E;
        next(res);
    } else {
        res[TransportMiddlewareProps.ResponseProp] = responseData;
        next();
    }
};
